var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"line-chart-container"},[_c('div',{staticClass:"line-chart-container__header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"line-chart-container__content"},[_c('line-chart-plain',{attrs:{"data":_vm.data,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }